import PropTypes from 'prop-types';

function SubtitleDivider(props) {
  return (
    <div className="hr-container">
      <span className="hr-text text-gray">{ props.children }</span>
      <span className="hr" />
    </div>
  );
}

SubtitleDivider.propTypes = {
  children: PropTypes.node,
};

export default SubtitleDivider;
